import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";

import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(private http: HttpClient) {}

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  public get(
    path: string,
    params: HttpParams = new HttpParams()
  ): Observable<any> {
    var options = { params };
    options["withCredentials"] = true; // in order to store local xsrf tokens

    return this.http
      .get(`${environment.api_url}${path}`, options)
      .pipe(catchError(this.formatErrors));
  }

  public put(path: string, body: Object = {}): Observable<any> {
    var options = {};
    options["withCredentials"] = true; // in order to store local xsrf tokens

    return this.http
      .put(`${environment.api_url}${path}`, JSON.stringify(body), options)
      .pipe(catchError(this.formatErrors));
  }

  public post(path: string, body: Object = {}): Observable<any> {
    var options = {};
    options["withCredentials"] = true; // in order to store local xsrf tokens

    return this.http
      .post(`${environment.api_url}${path}`, JSON.stringify(body), options)
      .pipe(catchError(this.formatErrors));
  }

  public delete(path): Observable<any> {
    var options = {};
    options["withCredentials"] = true; // in order to store local xsrf tokens

    return this.http
      .delete(`${environment.api_url}${path}`, options)
      .pipe(catchError(this.formatErrors));
  }
}
